import { BASE_URL } from "../main/constants/endpoints";

export const AUTH_URL_PREFIX = 'account';
export const API_URL_PREFIX = 'app';
export const DASHBOARD_URL_PREFIX = 'dashboard';

export const getContextUrl = (subDomain: string, envUrl: string): string => {
    if (envUrl === undefined || envUrl === null || envUrl === ''){
        return window.location.origin.replace(DASHBOARD_URL_PREFIX, subDomain);
    }

    return BASE_URL;
};